import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { HygieneInspectionStatus } from '../../../shared/models';
import type { SearchableInspectionResponse } from '../../../shared/models/CognitiveSearchResponse';

@Component({
  selector: 'backoffice-inspection-status-hygiene',
  templateUrl: './inspection-status-hygiene.component.html',
  styleUrls: ['./inspection-status-hygiene.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class InspectionStatusHygieneComponent {
  @Input() inspection!: SearchableInspectionResponse;

  readonly statusList = HygieneInspectionStatus;
}
